<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import CourseReviewCard from "@components/course/CourseReviewCard.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { Snippet } from "svelte";
	import { courseReviews } from "../../courseReviews.js";
	import translations from "./CourseReviewsSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
	const { children }: { children?: Snippet } = $props();
</script>

<section class="py-14 sm:py-17 md:py-20 full-width grid-container bg-fcrbeige">
	<div class="text-center mb-8 md:mb-12">
		<div class="uppercase text-fcrorange font-bold tracking-[.1em]">
			<Formatted text={translate("label")} />
		</div>
		<Heading level={2} text={translate("title")} class="heading-2 text-fcrdarkgray mt-4 mx-auto max-w-150" />
	</div>
	<div class="grid gap-4 md:gap-6 sm:grid-cols-2 lg:grid-cols-3">
		{#each courseReviews as review (review.name)}
			<CourseReviewCard {review} />
		{/each}
	</div>
	{#if children}
		<div class="mt-10 md:mt-12 flex justify-center">
			{@render children()}
		</div>
	{/if}
</section>
